import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Skeleton, Tree, Row, Col, Divider, Timeline, Pagination, Button, Modal } from "antd";
import { getinvoicelog } from "../../../actions/userlogAction";
import moment from "moment";

const List = ({ getinvoicelog, invoiceID }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const pageno = useRef(1);
  const page_size = useRef(100);

  useEffect(() => {
    getinvoicelog(pageno.current, page_size.current, 25, invoiceID).then(
      (result) => {
        setData(result);
        setLoading(false);
      }
    );
  }, [getinvoicelog, invoiceID]);

  const rendertable = (details) => {
    for (let key in details) {
      if (details.hasOwnProperty(key)) {
        console.log(key + ":");
        console.log("  Old Value: " + details[key].oldValue);
        console.log("  New Value: " + details[key].newValue);
      }
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (loading) {
    return <Skeleton active />;
  } else {
    return (
      <>
        <Button type="success" onClick={showModal}
        style={{ 
        backgroundColor: "green",
        color: "white",
        // marginBottom: 8,
        // borderRadius: 8,
        
        }}
        >
          Invoice History
        </Button>
        <Modal
          title="Invoice History"
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          width="70%"
          centered
          style={{ 
            // marginRight: 4,
            // marginLeft: 4,
            
           }}
        >
          <Timeline>
            {data.results.map((item) => {
              let event = item.action.split(" ")[0];
              let parts = item.action.split(/\(|\)/);
              let details = {};
              if (parts.length > 1) {
                console.log(parts[1]);
                let invoiceDetails = parts[1];
                let items = invoiceDetails.split(", "); // split by comma and space
                for (let i = 0; i < items.length; i++) {
                  let parts = items[i].split(": "); // split by colon and space

                  if (parts.length > 1) {
                    let key = parts[0];
                    let values = parts[1].split(" -> "); // split by arrow and space
                    let oldValue = values[0];
                    let newValue = values[1];
                    details[key] = {
                      oldValue: oldValue,
                      newValue: newValue,
                    };
                  }
                }
              }
              return (
                <Timeline.Item color="green">
                  <Row>
                    <Col flex="auto">
                      <h5>
                        {event} by {item.created_by}
                      </h5>
                    </Col>
                    <Col flex="200px">
                      <h5>
                        {moment(item.timestamp).format("YYYY-MM-DD hh:mm A")}
                      </h5>
                    </Col>
                  </Row>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {Object.entries(details).map(([key, value]) => {
                        return (
                          <tr key={key}>
                            <td>{key}</td>
                            <td>{value.oldValue}</td>
                            <td>{value.newValue}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Timeline.Item>
              );
            })}
          </Timeline>
        </Modal>
      </>
    );
  }
};

export default connect(null, {
  getinvoicelog,
})(List);
